import { useMutation } from '@tanstack/react-query';
import updateNumber from 'API/Numbers/updateNumber';
import { toast } from 'react-toastify';

const useUpdateNumber = ({
    data,
    accountScope,
    refetchNumber,
    refreshTable,
    previousEditNumberData,
    onClose,
}) => {
    return useMutation({
        mutationFn: async () => {
            if (
                JSON.stringify(data) === JSON.stringify(previousEditNumberData)
            ) {
                refetchNumber();
                return;
            }

            try {
                updateNumber({
                    updatedNumber: data,
                    currentScope: accountScope,
                })
                    .then((res) => {
                        refreshTable();
                        refetchNumber();
                        onClose;
                        toast.success('Number Updated');
                        return res;
                    })
                    .catch((err) => {
                        const error =
                            err?.response?.data?.message ||
                            'There is an error with updating number. Please try again.';
                        toast.error(error);
                    });
            } catch (error) {
                const errorMessage = `Failed to update number: ${error?.response?.data?.message}`;
                toast.error(errorMessage);
                throw new Error(errorMessage);
            }
        },
    });
};

export default useUpdateNumber;
